import { BlockHeroEntityHydrated } from "@jackfruit/common"

export const getTitle = (title: string) => {
  return title || "Block Title"
}

export const getContent = (content: string) => {
  return content
}

export const getAllPartnerLogos = (config: BlockHeroEntityHydrated) => {
  const {
    partnerLogo1,
    partnerLogo1Alt,
    partnerLogo2,
    partnerLogo2Alt,
    partnerLogo3,
    partnerLogo3Alt,
  } = config

  return [
    { path: partnerLogo1?.path, alt: partnerLogo1Alt },
    { path: partnerLogo2?.path, alt: partnerLogo2Alt },
    { path: partnerLogo3?.path, alt: partnerLogo3Alt },
  ].filter(logo => Boolean(logo.path))
}

export const getAllButtons = (config: BlockHeroEntityHydrated) => {
  const {
    primaryButtonLabel,
    primaryButtonAction,
    primaryButtonCustomAction,
    secondaryButtonLabel,
    secondaryButtonAction,
    secondaryButtonCustomAction,
    isPrimaryButtonEnabled,
    isSecondaryButtonEnabled,
  } = config

  const hasValidPrimaryButton =
    isPrimaryButtonEnabled && Boolean(primaryButtonLabel)

  const hasValidSecondaryButton =
    isSecondaryButtonEnabled && Boolean(secondaryButtonLabel)

  const allButtons = []

  if (hasValidPrimaryButton) {
    allButtons.push({
      label: primaryButtonLabel,
      action: primaryButtonAction,
      customAction: primaryButtonCustomAction,
      isPrimary: true,
    })
  }

  if (hasValidSecondaryButton) {
    allButtons.push({
      label: secondaryButtonLabel,
      action: secondaryButtonAction,
      customAction: secondaryButtonCustomAction,
      isPrimary: false,
    })
  }

  return allButtons
}

export const getAllBackgroundImages = (config: BlockHeroEntityHydrated) => {
  const {
    backgroundImageDesktop,
    backgroundImageDesktopAlt,
    backgroundImageTablet,
    backgroundImageTabletAlt,
    backgroundImageMobile,
    backgroundImageMobileAlt,
  } = config

  const allBackgroundImages = [
    {
      path: backgroundImageMobile?.path,
      alt: backgroundImageMobileAlt,
      type: "mobile",
    },
    {
      path: backgroundImageTablet?.path,
      alt: backgroundImageTabletAlt,
      type: "tablet",
    },
    {
      path: backgroundImageDesktop?.path,
      alt: backgroundImageDesktopAlt,
      type: "desktop",
    },
  ].filter(image => Boolean(image?.path))

  return allBackgroundImages
}
